import PropTypes from "prop-types"
import { connect } from "react-redux"

import Image from "components/ui/image"
import { IS_NA, IS_US, IS_JEWLR } from "helpers/application"
import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

const MainMethodImg = (props) => (
  <Image
    className="w-auto"
    height="24"
    style={{ height: "24px" }}
    width="34"
    {...props}
  />
)

const AltMethodImg = (props) => (
  <Image className="w-auto" style={{ height: "20px" }} {...props} />
)

const AcceptPayments = ({ canProcessApplePay, canProcessGooglePay }) => (
  <div className="mb-20 mt-16 py-10">
    <div className="mb-12 flex items-center justify-center gap-8">
      <p className="body-sm font-medium">Accepts:</p>
      <MainMethodImg alt="Visa" src={require("images/cart/visa.svg")} />
      <MainMethodImg
        alt="Mastercard"
        src={require("images/cart/mastercard.svg")}
      />
      {IS_NA() && (
        <MainMethodImg
          alt="American Express"
          src={require("images/cart/amex.svg")}
        />
      )}
      {IS_US() && (
        <MainMethodImg
          alt="Discover"
          height="22"
          src={require("images/cart/discover.svg")}
          width="32"
        />
      )}
    </div>
    {IS_JEWLR() && (
      <div className="flex items-center justify-center gap-10">
        {enableKlarnaCheckout() && (
          <AltMethodImg
            alt="Klarna"
            height="25"
            src={`${sl.config.jewlr_asset_url}images/cart/payment_methods/klarna_icon.png`}
            width="45"
          />
        )}
        {sl.config.enable_paypal && (
          <AltMethodImg
            alt="PayPal"
            height="16"
            src={require("images/cart/sticky_methods_paypal.svg")}
            width="58"
          />
        )}
        {canProcessApplePay && (
          <AltMethodImg
            alt="Apply Pay"
            height="209"
            src={require("images/cart/sticky_methods_apple.png")}
            width="500"
          />
        )}
        {canProcessGooglePay && (
          <AltMethodImg
            alt="Google Pay"
            height="16"
            src={require("images/cart/google-pay-checkout.svg")}
            width="41"
          />
        )}
      </div>
    )}
  </div>
)

const mapStateToProps = (state) => {
  return {
    canProcessApplePay: state.cartUI.canProcessApplePay,
    canProcessGooglePay: state.cartUI.canProcessGooglePay,
  }
}

AcceptPayments.propTypes = {
  canProcessApplePay: PropTypes.bool,
  canProcessGooglePay: PropTypes.bool,
}

export default connect(mapStateToProps)(AcceptPayments)
